/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import clsx from "clsx";
import {Link as GatsbyLink} from "gatsby";
import React, {memo, ReactNode} from "react";
import {createUseStyles} from "react-jss";
import UI from "./UI";

const useStyles = createUseStyles({
    root: {
        color: UI.colors.blue.toCSS(),
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
            textDecoration: "underline"
        }
    }
});

interface LinkProps {
    to?: string;
    href?: string;
    target?: string;
    children: ReactNode;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    className?: string;
    rel?: string;
}

export function Link(props: LinkProps) {
    const classes = useStyles();
    if (props.to) {
        return (
            <GatsbyLink to={props.to} className={clsx(classes.root, props.className)}>
                {props.children}
            </GatsbyLink>
        );
    }

    return (
        <a
            target={props.target}
            href={props.href || undefined}
            onClick={props.onClick}
            className={clsx(classes.root, props.className)}
            rel={props.rel}
        >
            {props.children}
        </a>
    );
}

export default memo(Link);
